'use client';

import { forwardRef } from 'react';
import { BaseClawInputView, type ChatInputProps, type ChatInputRef } from './BaseClawInputView';

/**
 * 正常对话态下的输入入口（`/claw/[sessionsId]` 已有 session）。
 *
 * 阶段 3：仅作为 `BaseClawInputView` 的薄壳 forwardRef 包装，保持外部 props/ref 形状不变；
 * 已有 session 的发送、stream 禁用态、附件 payload 等场景特有逻辑将在后续阶段统一收敛进来。
 *
 * 不要在这里复制基础输入视图的实现，所有共享行为继续走 `BaseClawInputView`。
 */
export type ConversationChatInputProps = ChatInputProps;
export type ConversationChatInputRef = ChatInputRef;

export const ConversationChatInput = forwardRef<ConversationChatInputRef, ConversationChatInputProps>((props, ref) => (
  <BaseClawInputView ref={ref} {...props} />
));

ConversationChatInput.displayName = 'ConversationChatInput';
